import React from "react";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import "react-loading-skeleton/dist/skeleton.css";

let loader = Array(8).fill(null);

function Loading() {
  return (
    <div className="mt-2">
      {loader.map((item, index) => (
        <div key={index} className="row">
          <div className="col-9">
            <SkeletonTheme key={index} baseColor="#ebebeb" highlightColor="#e5f3fd">
              <p>
                <Skeleton
                  className="w-50"
                  customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 50%, var(--base-color) 60%)"
                  count={1}
                />
                <Skeleton
                  className="w-100"
                  customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 50%, var(--base-color) 60%)"
                  count={1}
                />
              </p>
            </SkeletonTheme>
          </div>
          <div className="col-3">
          <SkeletonTheme highlightColor="#bdd5e7">
            <Skeleton
                  className="w-100 h-50"
                  customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 50%, var(--base-color) 60%)"
                  count={1}
                />
            </SkeletonTheme>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Loading;
